import React from 'react'
import { DragSource } from 'react-dnd'
import ItemTypes from '~/utils/TemplateEditor/dragDropItemTypes'
import Icons from '~/Common-Objects/UI/Icons'
import Icon from '~/Common-Objects/UI/Icon'
import { Tooltip } from 'react-tooltip'
import cloneDeep from 'lodash/cloneDeep'
const dragSource = {
    beginDrag(props) {
        // Hand over a private copy so we never mutate the shared palette object during hover/insert
        return { path: '', isNew: 0, content: cloneDeep(props.content) }
    },
    endDrag(props, monitor) {
        if (props.onStartDrag) props.onStartDrag()
        if (monitor.didDrop() === false) {
        }
    }
}

const NewElementObject = (props) => {
    const { canDrop, isOver, connectDragSource, isDragging, disabled = false } = props

    let thisIconName = 'dnd' + props.title
    thisIconName = thisIconName.replace(/ /g, '').toLowerCase()

    let icon = <Icons icon={thisIconName} color='#A9A9AD' />

    if (props.icon) {
        icon = <Icon name={props.icon} />
    }

    if (props.showLogo) {
        icon = (
            <img
                src={props.toolbarIcon}
                alt={props.title + ' Icon'}
                style={{
                    width: '100%',
                    height: '100%',
                    maxHeight: '32px'
                }}
            />
        )
    }

    let outerClass = 'dndEditorv2-leftToolsElementPicker-newElementObject'
    if (props.disabled) {
        outerClass += ' dndEditorv2-leftToolsElementPicker-newElementObject-disabled'
        return (
            <div
                className={outerClass}
                id={props.id}
                alt={props.title}
                title={props.title}
                style={props.style}
                data-tooltip-content={props.disabledExplainer}
                data-tooltip-id='leftElement-disabled-tooltip'
            >
                <div className={'dndEditorv2-leftToolsElementPicker-newElementObject-icon'}>{icon}</div>
                <span className={'dndEditorv2-leftToolsElementPicker-newElementObject-text'}>{props.title}</span>
                <Tooltip id='leftElement-disabled-tooltip' />
            </div>
        )
    }
    return connectDragSource(
        <div className={outerClass} id={props.id} alt={props.title} title={props.title} style={props.style}>
            <div className={'dndEditorv2-leftToolsElementPicker-newElementObject-icon'}>{icon}</div>
            <span className={'dndEditorv2-leftToolsElementPicker-newElementObject-text'}>{props.title}</span>
        </div>
    )
}

export default DragSource(ItemTypes.NEWITEM, dragSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
}))(NewElementObject)
